import { render, staticRenderFns } from "./Shroud.vue?vue&type=template&id=1864b1ac&"
import script from "./Shroud.vue?vue&type=script&lang=js&"
export * from "./Shroud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports